export const SET_RESULT = 'SET_RESULT';
export const RESET_BOX = 'RESET_BOX';
export const ENABLE_LOADING = 'ENABLE_LOADING';
export const DISABLE_LOADING = 'DISABLE_LOADING';

export const FETCH_RESULT_FAILED = 'FETCH_RESULT_FAILED';
